import type { WidgetCoreDefinition, TeXMLContext, TeXMLElement, ValidationResult } from './types';
import { isWithinBusinessHours, type BusinessHoursSchedule } from '../../businessHours';

export type HoursOfOperationConfig = {
  businessHoursIds: string[];
};

function generateTeXML(_config: HoursOfOperationConfig, _context: TeXMLContext): TeXMLElement[] {
  return [];
}

function resolveEdge(config: HoursOfOperationConfig, _variables: Record<string, string>): string | undefined {
  const resolvedSchedules = (config as HoursOfOperationConfig & { _resolvedSchedules?: BusinessHoursSchedule[] })
    ._resolvedSchedules;

  if (!resolvedSchedules || resolvedSchedules.length === 0) return 'closed';

  for (const schedule of resolvedSchedules) {
    if (isWithinBusinessHours(schedule)) return 'open';
  }

  return 'closed';
}

function validateConfig(config: HoursOfOperationConfig): ValidationResult {
  const errors: string[] = [];

  if (config.businessHoursIds.length === 0) {
    errors.push('At least one business hours schedule is required');
  }

  return { valid: errors.length === 0, errors };
}

export const hoursOfOperationWidgetCore: WidgetCoreDefinition<HoursOfOperationConfig> = {
  id: 'hoursOfOperation',
  version: 1,
  name: 'Hours of Operation',
  description: 'Route calls based on business hours schedules',
  category: 'control',
  tier: 'standard',

  defaultConfig: {
    businessHoursIds: [],
  },

  texml: {
    generate: generateTeXML,
    requiresCallback: false,
    resolveEdge,
  },

  validation: {
    validateConfig,
  },
};
